<script setup lang="ts">
import { LineupModel } from '@collector/desktop-feature-lineups'
import { runLoader, useConfirmModal } from '@collector/shared-ui'
import { Participant, SubParticipant } from '@collector/sportsapi-types'
import { useEvent } from '@desktop/views/Relation/composables'
import BaseLineupsModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/BaseLineupsModal/BaseLineupsModal.vue'
import InvalidAssignedPlayersConfirmModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/ConfirmModals/InvalidAssignedPlayersConfirmModal.vue'
import NoCaptainConfirmModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/ConfirmModals/NoCaptainConfirmModal.vue'
import NoCoachConfirmModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/ConfirmModals/NoCoachConfirmModal.vue'
import {
  UpdateLineupsFn,
  useLineupConfig,
} from '@desktop/views/Relation/Sports/composables'

import NoGoalkeeperConfirmModal from './components/ConfirmModals/NoGoalkeeperConfirmModal.vue'

interface Props {
  participant: Participant
}
const props = defineProps<Props>()

// composables
const { openModalForConfirm } = useConfirmModal()
const { config } = useLineupConfig()
const { event } = useEvent()

// methods
async function confirmUpdateLineup(
  lineup: LineupModel,
  _initialLineup: LineupModel,
  updateLineups: UpdateLineupsFn,
  captain?: SubParticipant | null,
): Promise<void> {
  const goalkeeperMax = config.value.positions.goalkeeper.maxCount ?? Infinity
  const goalkeeperCount = lineup.goalkeeper.length
  const firstLineupMax = config.value.positions.firstLineup.maxCount ?? Infinity
  const firstLineupCount = lineup.firstLineup.length
  const coachCount = lineup.coach.length

  if (goalkeeperCount === 0) await openModalForConfirm(NoGoalkeeperConfirmModal)
  if (goalkeeperCount + firstLineupCount !== goalkeeperMax + firstLineupMax)
    await openModalForConfirm(InvalidAssignedPlayersConfirmModal, {
      maxPlayersInFirstLineup: firstLineupMax + goalkeeperMax,
    })
  if (!captain) await openModalForConfirm(NoCaptainConfirmModal)
  if (coachCount === 0) await openModalForConfirm(NoCoachConfirmModal)

  await runLoader(updateLineups(event.value.id, props.participant.id, lineup))
}
</script>

<template>
  <BaseLineupsModal
    :participant
    :confirmUpdateLineup
  />
</template>
